import { render, staticRenderFns } from "./PageBox.vue?vue&type=template&id=68a4e9e0&scoped=true&"
import script from "./PageBox.vue?vue&type=script&lang=js&"
export * from "./PageBox.vue?vue&type=script&lang=js&"
import style0 from "./PageBox.vue?vue&type=style&index=0&id=68a4e9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a4e9e0",
  null
  
)

component.options.__file = "PageBox.vue"
export default component.exports